export const LOW_STOCK_THRESHOLD = 30;

const LOW_STOCK_THRESHOLDS_BY_UOM = {
    kg: 3,
    unit: 30,
    packet: 2,
    portion: 30,
};

export const getLowStockThresholdByUom = (uom) => {
    const normalizedUom = String(uom || '').trim().toLowerCase();
    return LOW_STOCK_THRESHOLDS_BY_UOM[normalizedUom] || LOW_STOCK_THRESHOLD;
};

export const getStockStatusLabel = (stock, lowStockThreshold = LOW_STOCK_THRESHOLD, isSubComponentAvailable) => {
    if (stock === 'Unlimited') {
        return 'IN STOCK';
    }

    const stockQuantity = Number(stock);
    if (stockQuantity <= 0) {
        return isSubComponentAvailable ? 'LOW STOCK' : 'OOS';
    }

    if (stockQuantity < LOW_STOCK_THRESHOLD) {
        return 'LOW STOCK';
    }

    return 'IN STOCK';
};

export const getStockStatusLabelByUom = (stock, uom, isSubComponentAvailable) =>
    getStockStatusLabel(stock, getLowStockThresholdByUom(uom), isSubComponentAvailable);
